import { DataFetchingClientProvider } from 'data-fetching-client';
import { pricingPageDataFetchingClient } from './pricingPageDataFetchingClient';
import { PricingPageRoutes } from './PricingPageRoutes';

// NOTE: DO NOT USE THIS COMPONENT FOR PRODUCTION CODE
// This is a temporary component to enable development of the new pricing page
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
export const PricingPageContainer = () => {
  return /*#__PURE__*/_jsx(_Fragment, {
    children: /*#__PURE__*/_jsx(DataFetchingClientProvider, {
      client: pricingPageDataFetchingClient,
      children: /*#__PURE__*/_jsx(PricingPageRoutes, {})
    })
  });
};